import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppSettings } from 'app/modules/shared/app.settings';
import { WeekMonthDatePipe } from 'app/modules/shared/pipes/week-month-date.pipe';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import { ConfirmationService } from 'primeng/api';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';

@Component({
  selector: 'app-team-member-slot-card',
  templateUrl: './team-member-slot-card.component.html',
  styleUrls: ['./team-member-slot-card.component.scss']
})
export class TeamMemberSlotCardComponent implements OnInit {
  @Input() teamShiftDetail: any;
  @Input() providerId: any;
  @Input() team: any;
  @Input() teamName: any;
  @Input() id: any;
  @Input() isPastDate: any;
  @Output() addTimeOffEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() editSlotOffEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() manageShiftSlot: EventEmitter<any> = new EventEmitter();
  @Output() cancelLeaveEmitter: EventEmitter<any> = new EventEmitter();
  shiftDetail: any[] = [];
  displayedShiftDetails: any[] = [];
  activeShiftDetail: any;
  hasShowOpenShiftPopUp: boolean;
  manageShiftDetails = {};
  showPopup = false;
  maxSlotLimitReached = false;
  bgCardClass = '';
  date: any;
  minDate = new Date();
  userTeam: any;
  shiftDetailCount: number;
  slotLength = 0;
  isPTOEnable;
  organizationLevelDispatch = false;
  providerLevelDutyFlag = false;
  teamLevelDutyFlag = false;

  constructor(private confirmationService: ConfirmationService,
    private commonService: CommonBindingDataService, private manageOpenShiftsService: ManageOpenShiftsService,
    private uiService: UiService) { }

  ngOnInit(): void {
    this.date = new Date(this.teamShiftDetail?.dateStr || this.minDate);
    this.isPTOEnable = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.PTO)?.value;
    this.userTeam = this.teamShiftDetail.userTeams || [];
    const teamMap = {};
    for (const team of this.userTeam) {
      const { teamName, slotTimeStr, leaveType, scheduleSource } = team;
          const slot = {
          slot: slotTimeStr,
          timeOff: leaveType ? true : false,
          scheduleSource: scheduleSource
        };
      const teamKey = teamName || '';
      if (!teamMap[teamKey]) {
        teamMap[teamKey] = { teamName: teamKey, slotTimeStr: [slot] };
      } else {
          teamMap[teamKey].slotTimeStr.push(slot);
      }
    }
    // Convert the values of teamMap into an array
    this.shiftDetail = Object.keys(teamMap).map(key => teamMap[key]);
    this.shiftDetailCount = this.userTeam.length;

    this.displayedShiftDetails = JSON.parse(JSON.stringify(this.shiftDetail.slice(0, 1)));
    this.maxSlotLimitReached = this.displayedShiftDetails.length ? this.displayedShiftDetails[0].slotTimeStr.length > 2 : false;
    this.slotLength = this.displayedShiftDetails.length > 0
      ? (this.displayedShiftDetails[0].slotTimeStr.length > 1 ? this.shiftDetailCount - 2 : this.shiftDetailCount - 1)
      : 0;
    if (this.maxSlotLimitReached) {
      this.displayedShiftDetails[0].slotTimeStr = this.displayedShiftDetails[0].slotTimeStr.slice(0, 2);
    }
    this.bgCardClass = this.manageOpenShiftsService.convertToCssClass(this.teamShiftDetail?.memberStatusStr);
    this.activeShiftDetail = this.teamShiftDetail.userTeams.find(team => team.leaveType !== null);
    this.organizationLevelDispatch = this.commonService.getGlobalConfigByKey(AppSettings.DISPATCH_LEVEL_DUTY_ON_OFF)?.value;
    this.providerLevelDutyFlag = this.commonService.checkForGlobalConfigDOOPL(
      AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL, this.providerId);
    this.teamLevelDutyFlag = this.commonService.checkConfigDOOTeamLevel(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL, this.team[0]?.teamId);
  }

  addSlot() {
    this.manageShiftDetails = {
      date: this.teamShiftDetail.dateStr,
      firstName: this.teamName?.firstName,
      lastName: this.teamName?.lastName,
      userId: this.id,
      providerId: this.team[0]?.providerId,
      scheduleSource: this.team[0]?.scheduleSource,
      teamId: this.team[0]?.teamId
    };
    this.addTimeOffEmitter.emit(this.manageShiftDetails);
  }

  editSlot() {
    this.manageShiftDetails = {
      date: this.teamShiftDetail.dateStr,
      firstName: this.teamName.firstName,
      lastName: this.teamName.lastName,
      team: this.teamShiftDetail.userTeams.length ? this.teamShiftDetail.userTeams[0].teamName : [],
      userId: this.id,
      providerId: this.providerId,
      teamId: this.team[0]?.teamId,
      userType: this.teamName?.userType
    };
    this.editSlotOffEmitter.emit(this.manageShiftDetails);
  }

  confirmCancelLeave() {
    const weekMonthDate = new WeekMonthDatePipe();
    this.confirmationService.confirm({
      message: `Are you sure you want to cancel ${this.teamName.firstName} ${this.teamName.lastName}'s leave for ${weekMonthDate.transform(this.teamShiftDetail.dateStr)} ?`,
      header: this.commonService.getLabel('label_cancel_leave'),
      accept: () => {
        this.cancelLeave();
      },
    });
  }

  cancelLeave() {
    this.manageOpenShiftsService.cancelMemberLeave(this.activeShiftDetail.scheduleId).subscribe((res) => {
      this.uiService.showMessage(res.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.cancelLeaveEmitter.emit(true);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

}
